/**
 * Internal-only surfaces, gated by localStorage so they never appear for
 * real users. Flip on from the devtools console:
 *
 *   localStorage.setItem('ev-internal-explorer', 'true')
 *
 * and reload; remove the key (or set anything else) to hide it again.
 */

export var INTERNAL_EXPLORER_KEY = 'ev-internal-explorer';
export function isInternalExplorerEnabled() {
  try {
    return window.localStorage.getItem(INTERNAL_EXPLORER_KEY) === 'true';
  } catch (_unused) {
    return false;
  }
}